import { useEffect } from 'react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { redactAllureTokenInEvent } from './allure/redactAllureToken';

export function DatadogRumInit() {
  const config = useApi(configApiRef);

  useEffect(() => {
    const rumConfig = config.getOptionalConfig('app.datadogRum');
    if (!rumConfig) {
      return;
    }

    const clientToken = rumConfig.getOptionalString('clientToken');
    const applicationId = rumConfig.getOptionalString('applicationId');
    if (!clientToken || !applicationId) {
      return;
    }

    datadogRum.init({
      clientToken,
      applicationId,
      site: rumConfig.getOptionalString('site') ?? 'datadoghq.eu',
      service: 'backstage-frontend',
      env: rumConfig.getOptionalString('env'),
      sessionSampleRate:
        rumConfig.getOptionalNumber('sessionSampleRate') ?? 100,
      sessionReplaySampleRate:
        rumConfig.getOptionalNumber('sessionReplaySampleRate') ?? 15,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin()],
      // The Allure tab's iframe URL carries a user token; never send it to Datadog.
      beforeSend: event => {
        redactAllureTokenInEvent(event);
        return true;
      },
    });

    datadogRum.setGlobalContext({
      experience: 'developer-experience',
      team: 'portfolio-and-api',
    });
  }, [config]);

  return null;
}
